<template>
    <div
        class="sidebar-menu-item"
        :class="{ selected: isSelected(item), 'is-private': item.isPrivate }"
        @click="fnCallback(item)"
        @dblclick="handleDoubleClick"
        @contextmenu="handleContextMenu"
        :data-menukey="item.dataKey"
        @mouseover="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <template v-if="item.icon.type === 'material-icons'">
            <div class="sidebar-menu-item-icon">
                <div class="material-icons">{{ item.icon.name }}</div>
                <div v-if="item.isPrivate" class="private-indicator">
                    <i class="material-icons">lock</i>
                </div>
            </div>
        </template>
        <template v-if="item.icon.type === 'chatbot'">
            <div class="sidebar-menu-item-icon">
                <div class="material-icons">
                    <Chatbot />
                </div>
            </div>
        </template>
        <template v-else-if="item.icon.type === 'component'">
            <div class="sidebar-menu-item-icon">
                <component
                    v-bind:is="item.icon.name"
                    id="component-icon"
                    :class="item.icon.class"
                    :style="item.icon.style"
                />
                <div v-if="item.isPrivate" class="private-indicator">
                    <i class="material-icons">lock</i>
                </div>
            </div>
        </template>
        <div class="sidebar-menu-item-content">
            <div class="sidebar-menu-item-text" :title="item.label">
                {{ item.label }}
            </div>
            <div class="action-container">
                <div class="sidebar-menu-item-badge" v-if="item.badge && !(showSearchButton && hoverActive)"></div>
                <div class="sidebar-menu-item-count" v-else-if="item.counter > 0 && !(showSearchButton && hoverActive)">
                    {{ getCounter() }}
                </div>
                <div v-if="showSearchButton && hoverActive" class="search-icon-overlay" @click.stop="handleSearch">
                    <i class="material-icons">search</i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InstagramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/InstagramIcon.vue";
import TicketIcon from "../svg/Ticket.vue";
import MessengerIcon from "../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import FacebookIcon from "../../views/Pages/Chatbot/pages/integrations/svg/NewFacebookIcon.vue";
import WhatsappIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import OfflineSupWaiting from "../svg/OfflineSupWaiting.vue";
import ArchiveIcon from "../svg/ArchiveIcon.vue";
import Chatbot from "../svg/Chatbot.vue";
import TrendyolIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import CreditCard from "../svg/CreditCard.vue";
import TelegramIcon from "../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import LinkedinIcon from "../../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";

export default {
    name: "SidebarChildItem",
    props: ["item", "isSelected", "isMenuActive", "showSearchButton", "searchCallback"],
    components: {
        InstagramIcon,
        MessengerIcon,
        WhatsappIcon,
        TelegramIcon,
        LinkedinIcon,
        TrendyolIcon,
        OfflineSupWaiting,
        ArchiveIcon,
        Chatbot,
        CreditCard,
        TicketIcon,
        FacebookIcon
    },
    data() {
        return {
            isActive: false,
            groupedItems: [],
            cloneItems: [],
            selectedItemClone: null,
            hoverActive: false,
        };
    },
    methods: {
        getCounter() {
            return this.item.counter >= 99 ? "99+" : this.item.counter;
        },
        fnCallback() {
            if (this.item.clickEvent) {
                this.$emit("clicked", this.item);
            } else {
                this.$emit("selected", this.item);
            }
        },
        handleSearch() {
            if (typeof this.searchCallback === "function") {
                this.searchCallback(this.item);
            }
        },
        handleDoubleClick() {
            if (typeof this.item.dblclickCallback === "function") {
                this.item.dblclickCallback();
            }
        },
        handleContextMenu(event) {
            if (this.item.contextMenuEnabled && typeof this.item.onContextMenu === "function") {
                event.preventDefault();
                event.stopPropagation();
                this.item.onContextMenu(event, this.item);
            }
        },
    },
};
</script>
<style lang="scss">
.hiddenToolTip {
    opacity: 0 !important;
    display: none !important;
}
</style>
<style lang="scss">
.sidebar-tool {
    width: 60px;
    border-right: 1px solid var(--color-border-default);
    height: 100%;
    position: relative;
    transition: all 0.2s;
    user-select: none;
    min-width: 60px;
    z-index: 1;

    .sidebar-content {
        height: calc(100% - 40px);
        overflow: auto;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &.active {
        width: 240px;
        min-width: 240px;

        .sidebar-menu-item {
            .sidebar-menu-item-content {
                display: flex !important;
                align-items: center !important;
                justify-content: space-between !important;
                width: 100% !important;
                gap: 8px !important;
            }

            .sidebar-menu-item-text {
                flex: 1 !important;
                min-width: 0 !important;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
            }
        }

        .sidebar-grouped {
            .sidebar-grouped-head {
                justify-content: space-between;

                .sidebar-grouped-head-title {
                    display: block !important;
                }
            }
        }

        .sidebar-tool-collapse {
            padding: 0 10px;
            justify-content: space-between;

            .information-text {
                display: block !important;
                color: #647491;
            }
        }
    }

    .sidebar-menu {
        transition: all 0.2s;
        max-height: 400px; // 10 item
        overflow: hidden;
        opacity: 1;

        &.closed {
            max-height: 0;
            opacity: 0;
        }
    }

    .sidebar-menu-content {
        padding: 11px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        line-height: 0;
        background: var(--white);
    }

    .sidebar-menu-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        padding: 8px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background: var(--color-bg-neutral-hover);
        }

        &.is-private {
            border-left: 2px solid #ff9800;
            padding-left: 6px;
        }

        .ig-background {
            fill: #d6249f;
        }

        .wp-background {
            fill: #58c963;
        }

        &.selected {
            background: #EEE7FF;

            .sidebar-menu-item-text {
                white-space: nowrap;
                color: #5625CC !important;
            }

            .sidebar-menu-item-count {
                color: #5625CC !important;
            }

            .material-icons {
                color: #5625CC !important;
            }

            .wp-background {
                fill: var(--color-icon-primary-default) !important;
            }

            .ig-background {
                fill: var(--color-icon-primary-default) !important;
            }

            .credit-card {
                fill: #5625CC !important
            }
        }

        &:not(&.selected) {
            .sidebar-menu-item-content {
                .sidebar-menu-item-text {
                    white-space: nowrap;
                    color: #3A3F48 !important;
                }
            }
        }

        .sidebar-menu-item-icon {
            width: 20px;
            height: 20px;
            font-size: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-right: 8px;

            svg {
                width: 100%;
                height: 100%;
            }

            .myIcon {
                width: 100%;
                height: 100%;
            }

            .material-icons {
                font-size: 20px;
                color: #3A3F48;
            }

            .minimize-badge {
                position: absolute;
                background: #FD6144;
                border: 1px solid var(--white);
                min-width: 8px;
                height: 8px;
                border-radius: 5px;
                top: -0px;
                right: -4px;
            }

            .private-indicator {
                position: absolute;
                bottom: -2px;
                right: -6px;
                width: 12px;
                height: 12px;
                background: var(--color-bg-default);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                i.material-icons {
                    font-size: 10px;
                    color: #ff9800;
                }
            }

            #component-icon {
                width: 20px;
                height: 20px;
            }
        }

        .sidebar-menu-item-content {
            display: none;

            .sidebar-menu-item-count {
                min-width: 24px;
                height: 20px;
                padding: 0 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 11px;
                font-weight: 600;
                line-height: 1;
                border-radius: 10px;
                background: var(--color-bg-neutral-subtle);
                //border: 1px solid var(--color-border-default);
                color: #FD6144;
            }
        }

        .sidebar-menu-item-text {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
            min-width: 0;
            color: var(--color-text-primary);
            font-size: 14px;
            line-height: 1.5;
        }
    }

    &.selected {
        .sidebar-menu-item-count {
            border: 1px solid var(--color-text-primary-strong-active);
            color: #5625CC !important;
        }
    }

    .sidebar-grouped {
        width: 100%;
        display: flex;
        flex-direction: column;

        .sidebar-grouped-head {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border: var(--color-border-default);
            border-style: solid;
            border-width: 1px 0;
            border-bottom-width: 0;
            padding: 7px 11px;
            cursor: pointer;

            .sidebar-grouped-head-title {
                display: none;
                white-space: nowrap;
                width: 100%;
                line-height: 0;
            }

            .sidebar-grouped-head-collapse {
                line-height: 0;

                .material-icons {
                    font-size: 16px;
                }
            }
        }
    }

    .sidebar-tool-collapse {
        position: absolute;
        border-top: 1px solid var(--color-border-default);
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        cursor: pointer;
        user-select: none;
        background-color: var(--color-bg-neutral-default);
        height: 40px;

        .information-text {
            display: none;
            white-space: nowrap;
        }
    }

    .sidebar-menu-item-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
        color: var(--color-text-primary);
    }
}

.sidebar-menu-item-content {
    position: relative;
    overflow: visible;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;

    .action-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 20px;
        min-height: 20px;
        flex-shrink: 0;

        .sidebar-menu-item-badge {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: #FD6144;
            min-width: 4px;
        }

        .search-icon-overlay {
            cursor: pointer;
            color: var(--color-text-primary-strong-active);
            font-size: 14px;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            //background-color: var(--color-bg-active);
            transition: background-color 0.3s, color 0.3s;

            .material-icons {
                font-size: 14px;
                color: var(--color-text-primary-strong-active);
            }

            &:hover {
                background-color: var(--color-bg-neutral-hover);
            }
        }
    }
}
</style>
